import { render, staticRenderFns } from "./CompanyGrowth.vue?vue&type=template&id=6195e84e&"
import script from "./CompanyGrowth.vue?vue&type=script&lang=ts&"
export * from "./CompanyGrowth.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyGrowth.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports